export const ICON_NAME_PREMIUM_PARTNER = 'ICON_NAME_PREMIUM_PARTNER';
export const ICON_NAME_MAIN_MENU = 'ICON_NAME_MAIN_MENU';
export const ICON_NAME_ARTIST = 'artist';
export const ICON_NAME_NEWS = 'news';
export const ICON_NAME_FANBOX = 'fanbox';
export const ICON_NAME_CLUB = 'club';
export const ICON_NAME_VIP = 'ICON_NAME_VIP';
export const ICON_NAME_STUDIOS = 'ICON_NAME_STUDIOS';
export const ICON_NAME_VOTE = 'ICON_NAME_VOTE';
export const ICON_NAME_WAY_FINDER = 'ICON_NAME_WAY_FINDER';
export const ICON_NAME_FAN_FEED = 'ICON_NAME_FAN_FEED';
export const ICON_NAME_PROMOTION = 'ICON_NAME_PROMOTION';
export const ICON_NAME_TEAM = 'ICON_NAME_TEAM';
export const ICON_NAME_FORUM = 'ICON_NAME_FORUM';
export const ICON_NAME_EVENTS = 'ICON_NAME_TEAM';
export const ICON_NAME_COMPETITION = 'ICON_NAME_COMPETITION';
export const ICON_NAME_OPPONENTS = 'ICON_NAME_OPPONENTS';
export const ICON_NAME_SETTINGS = 'ICON_NAME_SETTINGS';
export const ICON_NAME_MEMBERS = 'ICON_NAME_MEMBERS';
export const ICON_NAME_LEGAL = 'ICON_NAME_LEGAL';
export const ICON_NAME_BANNER = 'ICON_NAME_BANNER';
export const ICON_NAME_SHOP = 'ICON_NAME_SHOP';
export const ICON_NAME_STREAM = 'ICON_NAME_STREAM';
export const ICON_NAME_MICROPHONE = 'ICON_NAME_MICROPHONE';
export const ICON_NAME_DASHBOARD = 'ICON_NAME_DASHBOARD';
export const ICON_NAME_VIEW_EYE = 'ICON_NAME_VIEW_EYE';



// WEBPACK FOOTER //
// ./src/components/Icons/constants.ts